import { Box, Stack, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListTitle = styled(Box)(() => ({
  color: "#909195",
  fontSize: '0.875rem',
  fontWeight: 700,
  padding: '0 16px',
}));

export const List = styled(Box)(({ selected, disabled }) => ({
  padding: '4px 16px',
  backgroundColor: selected ? '#fffae5' : 'transparent',
  cursor: disabled ? 'not-allowed' : 'pointer', // 비활성화 상태일 때 커서 변경
  opacity: disabled ? 0.5 : 1, // 비활성화 상태에서 흐리게 표시
  pointerEvents: disabled ? 'none' : 'auto', // 비활성화 상태에서 클릭 방지
}));

export const ListUl = styled(Box)(() => ({
  position: 'relative',
  fontSize: '0.875rem',
  color: '#909195',
  marginLeft: 32,
  paddingRight:16,
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 3,
    height: 3,
    top: 8,
    left: -12,
    background: '#909195',
    borderRadius: 100
  }
}));

export const ExImage = styled('div')({
  width: '80px',
  height: '80px',
  overflow: 'hidden',
  position: 'relative',

});

export const StyledAccordion = styled(Accordion)(() => ({
  background: '#fff',
  borderRadius: '8px',
  boxShadow: 'none',
  border: '1px solid #F0F1F5',
  '&:before': { display: 'none' },
  '&.Mui-expanded': {
    margin: 0,
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  minHeight: 56,
  padding: '0 16px',
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 16,
  background: '#f7f8fa',
  '& .exImage': {
    "&:after": {
      content: '""',
      position: 'absolute',
      width: 11,
      height: 11,
      bottom: 21,
      right: 21,
      border: '1px solid rgb(254,83,107)',
      borderRadius: 100
    }
  }
}));

export const LanguageItem = styled(Stack)(({ selected, disabled }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#fff',
  border: selected ? '2px solid #FDD751' : '2px solid #fff',
  borderRadius: 8,
  padding: '8px 16px',
  transition: 'border 0.2s',
  cursor: disabled ? 'not-allowed' : 'pointer',
  height: '44px',
  boxSizing: 'border-box',
  opacity: disabled ? 0.3 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': {
    borderColor: selected ? '#FDD751' : '#E0E0E0',
  },
}));
